import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { storeSearchSerials } from 'store/reducers/mainSlice';

import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';

import { TbDatabaseExclamation } from 'react-icons/tb';
import StatusBadge from 'ui-component/StatusBadge';
import { FaDownload, FaSearch } from 'react-icons/fa';
import usePageTitle from 'hooks/usePageTitle';
import Filter from 'ui-component/filter-menu/Filter';
import { Skeleton } from '@mui/material';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import usePermissions from 'hooks/usePermissions';

import NoImage from 'assets/images/no-image.png';
import useIsMobile from 'utils/isMobileUtils';

import SerialDetailsModal from './components/SerialDetailsModal';

const Index = () => {
	const [setPageTitle] = usePageTitle('Serials');
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);

	const history = useNavigate();
	const [productList, setProductList] = useState([]);
	const [allPermissions, hasEveryPermission] = usePermissions();
	const [isLoading, setIsLoading] = useState(true);
	const [pagination, setpagination] = useState([]);
	const dispatch = useDispatch();

	const [searchField, setSearchField] = useState();
	const [searchValue, setSearchValue] = useState();
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [filters, setFilters] = useState([]);
	const [activeFilters, setActiveFilters] = useState({});
	const [isFirstLoad, setIsFirstLoad] = useState(true);
	const [selectedId, setSelectedId] = useState(null);
	const [showDetailPopup, setShowDetailPopup] = useState(false);


	const storedSearch = useSelector((state) => state.main.searchSerials);
	const storedFilter = useSelector((state) => state.main.filterSerials);


	// const getSerialsList = (internal = false) => {
	// 	// setIsLoading(true);
	// 	api.getSerialsList()
	// 		.then((res) => {
	// 			setProductList(res.data.data);
	// 			setpagination(res.data);
	// 			setIsLoading(false);
	// 			isFirstLoad && setIsFirstLoad(false);
	// 		})
	// 		.catch((err) => {
	// 			console.log(err);
	// 		});
	// };

	const viewData = (id) => {
		history(`/serials/${id}`);
	};

	const handleSearch = (e) => {
	
			let text = e.target.value;
			
			setIsLoading(true);
			setSearchValue(text);
			if (searchTimeout) {
				clearTimeout(searchTimeout);
			}
	
			// Only update searchField after user stops typing for 500ms
			let timeout = setTimeout(() => {
				dispatch(storeSearchSerials(text));
				setSearchField(text)	
			}, 500);
	
			setSearchTimeout(timeout);
		// let text = e.target.value;
		// setSearchField(text);

		// if (searchTimeout) {
		// 	clearTimeout(searchTimeout);
		// }

		// let timeout = setTimeout(() => {
		// 	setIsLoading(true);
		// 	if (text.length > 2) {
		// 		api.filterSerials(activeFilters, text).then((res) => {
		// 			setIsLoading(false);
		// 			setProductList(res.data.data);
		// 			setpagination(res.data);
		// 		});
		// 	} else if (text.length > 0 && text.length <= 2) {
		// 		setIsLoading(false);
		// 	} else {
		// 		api.filterSerials(activeFilters, null).then((res) => {
		// 			setIsLoading(false);
		// 			setProductList(res.data.data);
		// 			setpagination(res.data);
		// 		});
		// 	}
		// }, 1000);

		// setSearchTimeout(timeout);
	};

	// useEffect(() => {
	// 	// getSerialsList();
	// 	getFiltersList();
	// }, []);

	useEffect(() => {
		!isFirstLoad && handleFilter();
	}, [activeFilters]);

	const handleFilter = (activeF = null, searchF = null) => {
		setIsLoading(true);
		api.filterSerials(activeFilters, searchField?.length > 2 ? searchField : null).then((res) => {
			setIsLoading(false);
			setProductList(res.data.data);
			setpagination(res.data);
		});
	};

	// const getFiltersList = () => {
	// 	// api.getStockFilters('inbound').then((res) => {
	// 	// 	setFilters(res.data);
	// 	// });
	// };

	const isMobile = useIsMobile();



	const [dataList, setDataList] = useState([]);
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const tableRef = useRef();
	const [showPreloadingRows, setShowPreloadingRows] = useState(true);
	const [totalRecords, setTotalRecords] = useState(0);

	const [sortByFilter, setSortByFilter] = useState();

	const initializeData = () => {
		// Initial load
		let request = {}
		request.page = 1;
		request.search = searchField?.length > 2 ? searchField : null;
		
		
		api.getSerialsList(request, activeFilters, searchField, sortByFilter).then((res) => {
			
			setDataList([]);
			setTimeout(() => {
				setDataList(res?.data?.data?.data || []);

				setHasMore(true);
				setPage(1);
				// dispatch(setLoading(false));
				setIsLoading(false);
				setShowPreloadingRows(false);
				setTotalRecords(res?.data?.data?.total || 0);
			}, 300);
		});

	}



	useEffect(() => {
		// Only run fetchData after user stops typing (debounced by searchTimeout)
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		const timeout = setTimeout(() => {
			const fetchData = async () => {
				if (storedSearch) {
					await handleSearch({ target: { value: storedSearch } });
				}
				setDataList([]);
				initializeData();
				// getFiltersList();
			};
			fetchData();
		}, 500); // 500ms debounce

		setSearchTimeout(timeout);

		// Cleanup on unmount or before next effect run
		return () => clearTimeout(timeout);
		// Only trigger when these change
	}, [storedSearch, searchField, storedFilter]);


	useEffect(() => {
		setIsLoading(true);
	}, [activeFilters])

	useEffect(() => {
		const handleScroll = () => {
			if (!tableRef.current || showPreloadingRows || !hasMore) return;
			const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
			// Trigger only when user reaches the bottom (with a small threshold)
			if (scrollTop + clientHeight >= scrollHeight - 10) {
				loadMoreData();
			}
		};
		const currentRef = tableRef.current;
		if (currentRef) {
			currentRef.addEventListener('scroll', handleScroll);
		}
		return () => {
			if (currentRef) {
				currentRef.removeEventListener('scroll', handleScroll);
			}
		};
	}, [showPreloadingRows, hasMore, dataList]);

    const loadMoreData = () => {
        if (showPreloadingRows || !hasMore) return;
        setShowPreloadingRows(true);
        let request = {};
        request.page = page + 1;
        request.search = searchField?.length > 2 ? searchField : null;

        
        api.getSerialsList(request, activeFilters, searchField, sortByFilter).then((res) => {
            const nextPage = res?.data?.data?.meta?.current_page || request.page;
            const lastPage = res?.data?.data?.meta?.last_page || nextPage;
            if (nextPage > lastPage || res?.data?.data?.data?.length === 0) {
                setHasMore(false);
            } else {
                setDataList(prev => [...prev, ...res?.data?.data?.data || []]);
                setPage(nextPage);
            }
            setShowPreloadingRows(false);
        });
    };






	return (
		<>
			<div className="row justify-content-center">
				<div className={`medium-sized-container`} style={{ maxWidth: '900px' }}>
					<div className="col-xl-12 col-lg-12">
						<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
							<div className="header-bubble" />
							<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
								<h5 style={{ textAlign: 'center' }}>Serials</h5>
								<div style={{ height: '30px', opacity: 0 }} />
							</div>
						</div>
						{/* <div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
							<div className="header-bubble" />
							<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
								<h5 style={{ textAlign: 'center' }}>Serials</h5>
								<div
									style={{
										paddingLeft: 20,
										paddingRight: 20,
										display: 'flex',
										gap: 8,
										width: '100%',
										justifyContent: 'center',
										alignItems: 'center'
									}}
								>
									<Link to={''} className="btn btn-primary btn-outlined-main">
										<FaDownload /> Download
									</Link>
								</div>
							</div>
						</div> */}
						{/* <div className="section-head-new hide-on-mobile" style={{ margin: '10px 0' }}>
							<div className="actions">
								<Link to={''} className="btn btn-primary btn-outlined-main">
									<FaDownload /> Download
								</Link>
							</div>
						</div> */}
						<div className="hide-on-mobile" style={{ margin: '30px 0' }}></div>
						<div
							style={{
								justifyContent: 'space-between',
								alignItems: 'center',
								gap: 10,
								paddingLeft: '20px',
								paddingRight: 20,
								paddingBottom: 5
							}}
							className="show-on-mobile"
						>
							<form className="form-inline navbar-search" style={{ flex: 1 }}>
								<div style={{ position: 'relative', width: '100%' }}>
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
										value={searchValue || ''}
										onChange={handleSearch}
										style={{ width: '100%' }}
									/>
									<span
										className="searchIcon"
										style={{
											position: 'absolute',
											right: 10,
											top: '50%',
											transform: 'translateY(-50%)',
											color: '#888',
											pointerEvents: 'none'
										}}
									>
										<FaSearch />
									</span>
								</div>
							</form>
							<div style={{ flexShrink: 0 }}>
								<Filter activeFilters={activeFilters} onSubmit={setActiveFilters} filters={filters} />
							</div>
						</div>
						<div className={`card shadow-sm  bg-white mb-4 table-card ${isMobile ? 'shorter-table' : ''}`} style={{ overflowY: 'auto' }}>
							<div className=" align-items-center justify-content-between TableSerachBar">
								<div>
									<Filter activeFilters={activeFilters} onSubmit={setActiveFilters} filters={filters} />
								</div>
								<form className="form-inline navbar-search" onSubmit={(e) => e.preventDefault()}>
									<div className="input-group">
										<input
											type="text"
											className="form-control bg-white border"
											placeholder="Search"
											aria-label="Search"
											aria-describedby="basic-addon2"
											value={searchValue || ''}
											onChange={handleSearch}
											style={{ width: '100%' }}
										/>
										<span className="searchIcon">
											<FaSearch />
										</span>
									</div>
								</form>
							</div>
							{!isMobile && (
								<div
									className="table-responsive-xl tableData estimationList"
									ref={tableRef}
									style={{
										height: 'calc(100vh - 225px)',
										overflowY: 'auto',
										scrollbarWidth: 'thin',
										scrollbarColor: '#0966ff transparent'

									}}
								>
									<table className="table pm-table">
										<thead>
											<tr className="sticky-header">
												<th scope="col" colSpan={2}>
													Product
												</th>
												<th scope="col">IMEI</th>
												<th scope="col">Status</th>
											</tr>
										</thead>
										<tbody>
											{isLoading ? (
												[...Array(50)].map((e, i) => (
													<tr style={{ height: '65px' }} key={i}>
														{/* {[...Array(6)].map((e, i) => ( */}
															<td style={{ width: '50px' }}><Skeleton variant="rounded" width={'100%'} height={43} style={{ borderRadius: '12px' }} /></td>
															<td><Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} /></td>
															<td><Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} /></td>
															<td><Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} /></td>
														{/* ))} */}
													</tr>
												))
											) : (
												<>


													{dataList?.length > 0 && (
														dataList?.map((row, index) => {
															return (
																<tr key={index}>
																	<td
																		className={`align-middle`}
																		onClick={() => {
																			setShowDetailPopup(true)
																			setSelectedId(row.id);
																		}}
																		style={{ width: '50px' }}
																	>
																		<div>
																			{row?.thumbnail_url ? (
																				<img src={row?.thumbnail_url} style={{ width: '30px', height: '50px' }} />
																			) : row?.custom_thumbnail_url ? (
																				<img src={row?.custom_thumbnail_url} style={{ width: '30px', height: '50px' }} />
																			) : (
																				<img src={NoImage} style={{ width: '30px' }}  />
																			)}
																		</div>
																	</td>
																	<td
																		className={`align-middle`}
																		onClick={() => {
																			setShowDetailPopup(true)
																			setSelectedId(row.id);
																		}}
																		style={{
																			cursor: 'pointer'
																		}}
																	>
																		{row?.product}
																	</td>
																	<td
																		className="align-middle"
																		onClick={() => {
																			setShowDetailPopup(true)
																			setSelectedId(row.id);
																		}}
																		style={{
																			cursor: 'pointer'
																		}}
																	>
																		{row?.imei}
																	</td>
																	<td
																		className="align-middle"
																		onClick={() => {
																			setShowDetailPopup(true)
																			setSelectedId(row.id);
																		}}
																		style={{
																			cursor: 'pointer'
																		}}
																	>
																		<div style={{ width: '110px' }}>
																			{row?.status === 'inbound' ? (
																				<StatusBadge itemStatus={'Available'} />
																			) : (
																				<StatusBadge itemStatus={'Not Available'} />
																			)}
																		</div>
																	</td>
																</tr>
															);
														})
													)}
													{showPreloadingRows && (
														[...Array(100)].map((e, i) => (
															<tr style={{ height: '65px' }} key={i}>
																{/* {[...Array(6)].map((e, i) => ( */}
																	<td style={{ width: '50px' }}><Skeleton variant="rounded" width={'100%'} height={43} style={{ borderRadius: '12px' }} /></td>
																	<td><Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} /></td>
																	<td><Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} /></td>
																	<td><Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} /></td>
																{/* ))} */}
															</tr>
														))
													)}
													{(dataList?.length < 1 && !isLoading) && (
														<tr className="no-hover">
															<td colSpan={6} className="whitebg">
																<div className="not-found-container">
																		<div className="not-found-icon">
																		<img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
																		
																	</div>
																	<h6 className="not-found-text">No Data Available</h6>

																</div>
															</td>
														</tr>
													)}
														

												</>
											)}
										</tbody>
									</table>
								</div>
							)}
							{isMobile && (
								<div
									className="picklists-mobile-list"
									ref={tableRef}
									style={{
										height: `calc(100dvh - ${Object.keys(activeFilters).length === 0 ? '305px' : '332px' })`,
										overflowY: 'auto',
										display: 'flex',
										flexDirection: 'column'
									}}
								>


									{isLoading ? (
										[...Array(50)].map((_, i) => (
											<div
												key={i}
												className="mobile-product-card skeleton"
												style={{ borderRadius: 12, background: '#f5f5f5', padding: 16, minHeight: 80 }}
											>
												<Skeleton variant="rounded" width={'100%'} height={60} />
											</div>
										))
									) : (
										<>
												
											{dataList.map((row, index) => (
												<div
													key={index}
													className="mobile-serials-card"
													style={{
														borderBottom: '1px solid #eee',
														padding: '10px 20px',
														background: index % 2 === 0 ? '#f9f9f9' : '#fff',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'space-between',
														gap: 12,
														width: '100%'
													}}
												>
													<div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 5 }}>
														<div style={{ fontWeight: 500, fontSize: 14 }}>{row?.product}</div>
														<div className="text-gray-800" style={{ display: 'flex', gap: 5, alignItems: 'center', fontSize: 13 }}>IMEI: {row?.imei}</div>
													</div>
													<div
														style={{
															position: 'relative',
															width: 80,
															height: 80,
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'center',
															borderRadius: 8,
															flexShrink: 0
														}}
													>
														<div
															style={{
																position: 'absolute',
																top: '50%',
																left: '50%',
																transform: 'translate(-50%, -50%)',
																zIndex: 2,
																width: '90px'
															}}
														>
															<StatusBadge itemStatus={row?.status === 'inbound' ? 'Available' : 'Not Available'} />
														</div>
														<img
															src={row?.thumbnail_url || row?.custom_thumbnail_url || NoImage}
															style={{
																width: 'auto',
																height: 80,
																objectFit: 'contain',
																display: 'block',
																margin: '0 auto'
															}}
														/>
													</div>
												</div>
											))}
											{showPreloadingRows && (
												[...Array(100)].map((_, idx) => (
													<div
														key={idx}
														className="order-list-card"
														style={{
															background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
															marginBottom: 10,
															borderRadius: 12,
															padding: 16,
															minHeight: 90,
															display: 'flex',
															flexDirection: 'column',
															gap: 10
														}}
													>
														{[...Array(3)].map((__, i) => (
															<div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
																<Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
															</div>
														))}
													</div>
												))
											)}
											{(dataList?.length < 1 && !isLoading) && (
												<div className="w-100">
													<div className="not-found-container">
														<div className="not-found-icon">
															<TbDatabaseExclamation />
														</div>
														<h6 className="not-found-text">No Data Available</h6>

													</div>
												</div>
											)}
										</>
									)}


								</div>
							)}
							<div
								className="hide-on-mobile"
								style={{
									padding: '10px 0px 10px 20px',
									borderTop: '1px solid #e0e0e0e0',
									display: 'flex',
									gap: '5px',
									justifyContent: 'space-between',
									height: '45px',
								}}
							>

								<div className="flex align-items-center" style={{ gap: '10px' }}>
									
								</div>
								<div className="flex align-items-center ml-auto" style={{ gap: '5px', paddingRight: '25px' }}>
									{isLoading ? (
										<div style={{ width: '100px' }}>
											<Skeleton variant="rounded" width={'100%'} height={20} />
										</div>
									) : (
										<>
											<div className="text-gray-800">Total Record:</div>
											<div className="fw-500">
													{totalRecords.toLocaleString('en-US')}
											</div>
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{showDetailPopup && (
				<SerialDetailsModal
					show={showDetailPopup}
					id={selectedId}
					handleClose={() => { setShowDetailPopup(false); setSelectedId(null); }}
				/>
			)}
		</>
	);
};

export default Index;